var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 0.828125C2.85449 0.828125 0.0361328 3.64648 0.0361328 7.125C0.0361328 10.6035 2.85449 13.4219 6.33301 13.4219C9.81152 13.4219 12.6299 10.6035 12.6299 7.125C12.6299 3.64648 9.81152 0.828125 6.33301 0.828125ZM11.8174 7.125C11.8174 10.1465 9.35449 12.6094 6.33301 12.6094C3.31152 12.6094 0.848633 10.1719 0.848633 7.125C0.848633 4.12891 3.28613 1.64062 6.33301 1.64062C9.3291 1.64062 11.8174 4.10352 11.8174 7.125ZM9.45605 7.02344L9.27832 6.8457C9.15137 6.71875 8.97363 6.71875 8.84668 6.8457L6.76465 9.0293V4.17969C6.76465 4.02734 6.6123 3.875 6.45996 3.875H6.20605C6.02832 3.875 5.90137 4.02734 5.90137 4.17969V9.0293L3.79395 6.8457C3.66699 6.71875 3.48926 6.71875 3.3623 6.8457L3.18457 7.02344C3.05762 7.15039 3.05762 7.32812 3.18457 7.45508L6.10449 10.375C6.23145 10.502 6.40918 10.502 6.53613 10.375L9.45605 7.45508C9.58301 7.32812 9.58301 7.15039 9.45605 7.02344Z",
    fill: "#383838"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.045a8961.svg";
export { ForwardRef as ReactComponent };